// 積分相關翻譯

export const credits = {
    availableCredits: '可用積分',
    creditsUsed: '已使用積分',
    totalCredits: '總積分',
    buyCredits: '購買積分',
    freeCredits: '免費積分',
    paidCredits: '付費積分',
    credits: '積分',
    remainingCredits: '剩餘積分',
    recharge: '充值',
    transactionHistory: '交易記錄',
    transactionNo: '交易編號',
    amount: '金額',
    transactionTime: '交易時間',
    noTransactionRecords: '暫無交易記錄',
    transactionType: {
      title: '交易類型',
      earned: '獲得',
      spent: '消費',
      refunded: '退款',
      catooGenerate: 'Catoo生成',
      newUserReward: '新用戶獎勵'
    }
  };
